import React, { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import { Calendar } from "feather-icons-react/build/IconComponents";
import {
  getTaxList,
  getUnitList,
  getCustomersList,
  getWareHouseList,
} from "../../../services/MasterApiServices";
import PlusCircle from "feather-icons-react/build/IconComponents/PlusCircle";
import { useSelector } from "react-redux";
import { InvSales } from "../../../core/json/invSales";
import { FinancialYear } from "../../../core/json/FinancialYear";
import {
  addEditSales,
  getSalesByTransType,
} from "../../../services/SalesApiServices";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  fetchUnit,
  // fetchProductAll,
  fetchTax,
  fetchSettings,
  fetchCustomer,
  fetchProduct,
} from "../../../redux/userSetting";
import CustomerModal from "../../master/modal/CustomerModal";
import { label } from "yet-another-react-lightbox";
import QRCode from "qrcode";
import { Buffer } from "buffer";
import { getPrintSettingsByBranch } from "../../../services/AdminApiServices";


const SalesQuotationModal = ({ mode, data, handleClose, handleRefresh }) => {
  
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invdate: dayjs().format("YYYY-MM-DD"),
      addition: 0,
      subtraction: 0,
      round: 0,
      paymentType: 0,
    },
    mode: "onBlur",
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  // Get branch from redux
  const { branch } = useSelector((state) => state.branchlist);
  const dispatch = useDispatch();

  const [taxvalue, setTaxvalue] = useState([]);
  const [unitData, setunitData] = useState([]);

const [printAfterSubmit, setPrintAfterSubmit] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [salesData, setsalesData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const [printSettings, setPrintSettings] = useState(null);
  const {
    // productAllList,
    productList,
    unitList,
    settingList,
    customerList,
    taxList,
    // formatedproductListAll,
    formatedproductList,
  } = useSelector((state) => state.usersetting);
  const { branchsettings } = useSelector((state) => state.settings);

  const { companyInfolist } = useSelector((state) => state.companyInfo);
  useEffect(() => {}, [branch]);

  const paymentType = [
    { value: 0, label: "Cash" },
    { value: 1, label: "Credit" },
    { value: 2, label: "UPI" },
    { value: 3, label: "Card" },
    { value: 4, label: "MultiPayment" },
  ];

  const salesMode = [
    { value: 0, label: "NORMAL SERIES" },
    { value: 1, label: "QUOT SERIES" },
  ];
  const { userId } = useSelector((state) => state.userauth);
// console.log(productList,"produccccccc");



const [warehouses, setWarehouses] = useState([]);

useEffect(() => {
  const fetchPrintSettings = async () => {
    try {
      const response = await getPrintSettingsByBranch(branch?.guid);
      setPrintSettings(response);
    } catch (error) {
      console.error("Failed to fetch print settings", error);
    }
  };

  if (branch?.guid) {
    fetchPrintSettings();
  }
}, [branch]);

useEffect(() => {
  const fetchWarehouses = async () => {
    try {
      const response = await getWareHouseList();

      if (Array.isArray(response)) {
        // Filter warehouses by current branch
        const filtered = response.filter(
          (wh) => wh.branchID === branch?.guid
        );
        setWarehouses(filtered);
      } else {
        setWarehouses([]);
      }
    } catch (err) {
      console.error("Failed to fetch warehouses:", err);
    }
  };
  if (branch?.guid) {
    fetchWarehouses();
  }
}, [branch]);



  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch))
    // dispatch(fetchProductAll());
    dispatch(fetchTax());
    dispatch(fetchSettings(branch));

    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
  }, []);

  //Calculations ---------------
  const safeNumber = (value, defaultValue = 0) => {
    // Check for null, undefined, or empty string and use the default value
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }

    // Convert to number
    const num = Number(value);

    // Return the number or the default value if num is NaN
    return isNaN(num) ? defaultValue : num;
  };
  const rowUseForm = getValues("row") || [];

  let totalGross = 0;
  let totalDiscount = 0;
  let totalTax = 0;
  let totalNet = 0;

  fields.forEach((field, index) => {
    const quantity = watch(`items[${index}].quantity`, 0);
    const price = watch(`items[${index}].price`, 0);
    const discount = watch(`items[${index}].discountPercentage`, 0);
    // const taxGUID = watch(`items[${index}].taxPercentage`, 0);
    // const tax = taxvalue.find((t)=>t.guid==taxGUID)?.value || 0;
// const taxPercent = watch(`items[${index}].taxPercentage`, 0);
// const tax = Number(taxPercent) || 0;
const taxGUID = watch(`items[${index}].taxPercentage`, 0);
const tax = taxvalue.find((t) => t.guid == taxGUID)?.value || 0;

    
    const grossTl = price * quantity || 0;
    const discountAmt = (grossTl * discount) / 100 || 0;
    const amountBeforeTax = grossTl - discountAmt || 0;
    const taxAmount = (amountBeforeTax * tax) / 100 || 0;
    const netTotal = amountBeforeTax + taxAmount || 0;

    setValue(`items[${index}].gross`, grossTl?.toFixed(decimalpoints));
    setValue(
      `items[${index}].discountAmount`,
      discountAmt?.toFixed(decimalpoints)
    );
    setValue(`items[${index}].taxAmount`, taxAmount?.toFixed(decimalpoints));
    setValue(`items[${index}].netTotal`, netTotal?.toFixed(decimalpoints));


    // Add to totalGross
    totalGross += grossTl;
    totalDiscount += discountAmt;
    totalTax += taxAmount;
    totalNet += netTotal;
  });
  //Final calculations on addition ,discount and round
  const addition = Number(watch(`addition`, 0));
  const subtraction = Number(watch(`subtraction`, 0));
  const round = Number(watch(`round`, 0));

  totalNet += safeNumber(addition);
  totalNet -= safeNumber(subtraction);
  totalNet -= safeNumber(round);
  totalDiscount = totalDiscount + safeNumber(subtraction);
  //end-------------
  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one product entry is required");
    }
  }
  const handleUnitList = async () => {
    try {
      const response = await getUnitList();
      const formattedUnit = response?.map((unit) => ({
        label: unit.name,
        value: unit.guid,
      }));
   
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  // const handleTaxList = async () => {
  //   try {
  //     const response = await getTaxList();

  //     const formattedTax = response?.map((tax) => ({
  //       label: tax.percentage,
  //       value: tax.percentage,
  //       guid: tax.guid,
  //     }));
  //     setTaxvalue(formattedTax);

      
      
  //   } catch (error) {
  //     console.error(
  //       "Error fetching tax",
  //       error?.response?.data?.Message || "something went wrong"
  //     );
  //   }
  // };

  const handleTaxList = async () => {
  try {
    const response = await getTaxList();
const formattedTax = (response || []).map((tax) => ({
  label: `${tax.percentage}%`,
  value: tax.percentage,
  guid: tax.guid,
  percentage: Number(tax.percentage),
}));

    setTaxvalue(formattedTax);
  } catch (error) {
    console.error("Error fetching tax", error);
  }
};

// Helper function to get selected tax option by percentage
const getSelectedTaxOption = (value) => {
  if (!value || !taxvalue?.length) return null;
  return taxvalue.find((option) => option.guid === value) || null;
};


  const handleEachProductfetch = async (selectedOption, index) => {
    setValue(`items[${index}].product`, selectedOption.value);
    try {
      const productData = productList?.find(
        (e) => e.guid == selectedOption.value
      );
  
      console.log("selectedProduct",productData);
      if (!productData) {
        console.error("Product not found for GUID:", selectedOption.value);
        return;
      }
      setValue(`items[${index}].code`, productData?.code || 0);
      // setValue(`items[${index}].hsnCode`, productData?.hsnCode || 0);
      setValue(`items[${index}].unit`, productData?.unit || 0);
      setValue(`items[${index}].taxPercentage`,productData?.taxID);
      setValue(`items[${index}].price`, productData?.retailRate || 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleCustomerList = async () => {
    try {
      // const response = await getCustomersList(branch);
      const formattedCustomers = customerList?.map((customer) => ({
        label: customer.name,
        value: customer.guid,
      }));
      setCustomerData(formattedCustomers);
    } catch (error) {
      console.error(
        "Error fetching customers",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };


//   const formattedWarehouses = warehouses?.map((wh) => ({
//   label: wh.name,
//   value: wh, // store full object here
// }));

const formattedWarehouses = Array.isArray(warehouses)
  ? warehouses.map((warehouse) => ({
      label: warehouse.name || "Unnamed Warehouse",
      value: warehouse,
    }))
  : [];

// Helper function to get selected warehouse option
const getSelectedWarehouseOption = (warehouse) => {
  if (!warehouse) return null;
  return (
    formattedWarehouses.find((wh) => wh.value.guid === warehouse.guid) || {
      label: warehouse.name || "Select Warehouse",
      value: warehouse,
    }
  );
};


  const handlesalesData = async () => {
    try {
      const response = await getSalesByTransType(branch, 0);
      setsalesData(response.data);
    } catch (error) {
      console.error(
        "Failed to fetch sales quotations",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  // Fetch sales quotations data
  const handleEntryNo = async () => {
    try {
      const response = await getSalesByTransType(branch, 0);
      const salesData = response.data;

      // Group entry numbers by prefix
      const entryGroups = salesData.reduce((groups, data) => {
        const entrynumber = data.entrynumber;
        // Extract the prefix (non-numeric characters)
        const prefix = entrynumber.match(/^[A-Za-z]+/)[0];
        // Extract the numeric part and convert it to an integer
        const entryNum = parseInt(entrynumber.replace(/\D/g, ""), 10);

        if (!groups[prefix]) {
          groups[prefix] = [];
        }
        groups[prefix].push(entryNum);

        return groups;
      }, {});

      // Get the desired prefix (e.g., "SQ")
      const prefix = "SQ";
      const maxEntryNumber =
        entryGroups[prefix]?.length > 0 ? Math.max(...entryGroups[prefix]) : 0;

      // Increment the counter for the prefix
      const counter = maxEntryNumber + 1;

      // Set the new entry number with the updated counter
      setValue(`entrynumber`, `${prefix}${counter}`);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

//   function resetmodal() {
//     if (mode === "edit" && data) {
//       setValue("terms", data.terms);
//       setValue("entrynumber", data.entrynumber);
    
//       setValue("salesTransType", data.salesTransType || 0);
//       setValue("addition", data.additionalAmt || 0);
//       setValue("subtraction", data.discAmt || 0);
//       setValue("round", data.roundOff || 0);
//       setValue("grossTotal", data.grossTotal || 0);
//       setValue("taxTotal", data.taxTotal || 0);
//       setValue("netAmt", data.netAmt || 0);
//       setValue("paymentType", data.salesPaymentType || 0);
  

//       setValue("customer", data.customer.guid);
//       setValue("invdate", dayjs(data.invdate) || dayjs());
//       setValue("deliveryDate", dayjs(data.deliveryDate) || dayjs());
//     // Assign warehouse using helper
//   //  if (data.location?.guid) {
//   //     const selectedWarehouse = getSelectedWarehouseOption(data.location);
//   //     setValue("location", selectedWarehouse.value || data.location);
//   //   }
//       if (data.location?.guid) {
//       const selectedWarehouse = getSelectedWarehouseOption(data.location);
//       setValue("location", selectedWarehouse.value || data.location);
//     } else if (!data.location && branchsettings?.defaultWareHouseID) {
//       // Set default warehouse from branch settings
//       const defaultWH = warehouses.find(
//         (wh) => wh.guid === branchsettings.defaultWareHouseID
//       );
//       if (defaultWH) {
//         const selectedWarehouse = getSelectedWarehouseOption(defaultWH);
//         setValue("location", selectedWarehouse.value);
//       }
//     }
  
//     }
//     data?.invSalesDetails?.map((detail, i) => {
//       console.log(detail?.product?.guid, "-----------detail");
//     });

//  setValue(
//   "items",
//   (data?.invSalesDetails || []).map((detail) => {
//     // match the tax from list using taxPercentage
//     const matchedTax = taxvalue.find(
//       (t) => Number(t.percentage) === Number(detail?.taxPercentage)
//     );

//     return {
//       product: detail?.product?.guid || null,
//       code: detail?.product?.code || "",
//       expirydate: detail?.expiryDate
//         ? dayjs(detail.expiryDate).format("YYYY-MM-DD")
//         : dayjs().format("YYYY-MM-DD"),
//       unit: detail?.unit?.guid || null,
//       quantity: detail?.quantity ?? 0,
//       price: detail?.price ?? 0,
//       mrp: detail?.mrp ?? 0,
//       foc: detail?.foc ?? 0,
//       discountPercentage: detail?.discPercentage ?? 0,
//       discountAmount: detail?.discAmt ?? 0,
//       gross: detail?.gross ?? 0,
//       taxAmount: detail?.taxamnt ?? 0,
//       netTotal: detail?.netAmt ?? 0,

//       // ✅ important part:
//       tax: matchedTax ? matchedTax.value : null, // GUID used by Select
//       taxPercentage: detail?.taxPercentage ?? 0, // numeric value used in calc
//     };
//   })
// );

//   }
//   console.log(getValues().items);
//   useEffect(() => {
//   if (mode === "edit" && Object.keys(data).length > 0) {
//     resetmodal(); // Only for editing existing data
//   }
// }, [data]);
  // useEffect(() => {
  //   resetmodal();
  // }, [data, append, remove]);

    async function resetmodal() {
  if (mode === "edit" && data) {
    setValue("terms", data.terms);
    setValue("entrynumber", data.entrynumber);
    setValue("salesMode", data.salesMode || 0);
    setValue("salesTransType", data.salesTransType || 2);
    setValue("paid", data.paid || 0);
    setValue("change", Number(data.change) || 0);
    setValue("refNo", data.refNo || 0);
    setValue("dispatch", data.dispatch || "");
    setValue("dispatchTrough", data.dispatchTrough || "");
    setValue("addition", data.additionalAmt || 0);
    setValue("subtraction", data.discAmt || 0);
    setValue("round", data.roundOff || 0);
    setValue("grossTotal", data.grossTotal || 0);
    setValue("discountTotal", data.discountTotal || 0);
    setValue("taxTotal", data.taxTotal || 0);
    setValue("netAmt", data.netTotal || 0);
    setValue("paymentType", data.salesPaymentType || 0);
    setValue("referencetype", data.reftype || 0);
    setValue("customer", data.customer.guid);
    setValue("customerContactno", data.customerContactno || "0");
    setValue("customerName", data.customerName || "");
    setValue("invdate", dayjs(data.invdate) || dayjs());
    setValue("deliveryDate", dayjs(data.deliveryDate) || dayjs());
   if (data.location?.guid) {
      const selectedWarehouse = getSelectedWarehouseOption(data.location);
      setValue("location", selectedWarehouse.value || data.location);
    }
    // Map items properly
    const items = data.invSalesDetails.map((detail) => {
      const taxGuid =
        taxvalue.find((t) => Number(t.value) === Number(detail.taxPercentage))
          ?.guid || null;

      return {
        product: detail?.product?.guid,
        code: detail?.product?.code,
        batch: detail.batch,
        expiry: dayjs(detail.expiryDate),
        unit: detail.unit?.guid,
        quantity: detail.quantity,
        price: detail.price,
        mrp: detail.mrp,
        foc: detail.foc,
        discountPercentage: detail.discPercentage,
        discountAmount: detail.discAmt,
        taxPercentage: taxGuid, // GUID of the tax
        gross: detail.gross,
        taxAmount: detail.taxamnt,
        netTotal: detail.netAmt,
      };
    });

    setValue("items", items);
  }
}

useEffect(() => {
  if (data && taxvalue.length) {
    resetmodal();
  }
}, [data, taxvalue]);

  useEffect(() => {
    handleCustomerList();
  }, [customerList]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (mode === "add") {
  //       handleEntryNo();
  //       if (!isRowAdded && fields?.length === 0) {
  //         handleAddRow();
  //         setIsRowAdded(true);
  //       }
  //     }

  //     handleTaxList();
  //     handleUnitList();
  //     handlesalesData();
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
  const fetchData = async () => {
    if (mode === "add") {
      handleEntryNo();
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }

      // Set default warehouse
      if (branchsettings?.defaultWareHouseID) {
        const defaultWH = warehouses.find(
          (wh) => wh.guid === branchsettings.defaultWareHouseID
        );
        if (defaultWH) {
          const selectedWarehouse = getSelectedWarehouseOption(defaultWH);
          setValue("location", selectedWarehouse.value);
        }
      }
    }

    handleTaxList();
    handleUnitList();
    handlesalesData();
  };

  fetchData();
}, [branchsettings, warehouses]);

  async function getUnitByGuid(guid) {
    const unitData = await getUnitList();
    const filteredData = unitData.filter((unit) => unit.guid === guid);
    return filteredData[0];
  }

  async function getTaxByGuid(guid) {
    const taxvalue = await getTaxList();
    const filteredData = taxvalue.filter((tax) => tax.guid === guid);
    return filteredData[0];
  }

  async function getProductByGuid(guid) {
    const filteredData =  productList?.filter(
      (product) => product.guid === guid
    );
    console.log("filteredData[0]", filteredData[0]);
    return filteredData[0];
  }
  const handleAddRow = () => {
    append({
      // batch: "0",
      code: "0",
      // discountAmount: "0.0",
      // discountPercentage: "0.0",
      //expiry: dayjs().format("YYYY-MM-DD"),
      foc: "0.0",
      gross: "0.0",
      // hsnCode: 0,
      mrp: "0.0",
      netTotal: "0.0",
      price: "0.0",
      quantity: "0",
      taxAmount: "0.0",
      taxPercentage: "0",
      unit: "",
      product: null,
    });
  };
  const handleFormSubmit = async (formdata) => {
    const objsales = new InvSales();
    if (mode === "edit") {
      objsales.guid = data?.guid;
      objsales.id = data?.id;
    }
    objsales.entrynumber = formdata.entrynumber || 0;
    objsales.branch = branch;
    objsales.invdate = dayjs(formdata.invdate)?.format("YYYY-MM-DDTHH:mm:ss");
    objsales.deliveryDate = dayjs(formdata.deliveryDate)?.format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    objsales.salesPaymentType = formdata.paymentType;
    objsales.salesTransType = 0;
    const customerData = customerList?.find((e) => e.guid == formdata.customer);
  
    console.log("customerData",customerData);
   // objsales.location = formdata.location ;
   objsales.location = formdata.location || 
  warehouses.find((wh) => wh.guid === branchsettings.defaultWareHouseID);
    objsales.updatedUser = `${userId?.id}`;
    objsales.createdUser = `${userId?.id}`;
    objsales.customer = customerData;
    objsales.currency = "00000000-0000-0000-0000-000000000000";
    objsales.dispatch = formdata.dispatch || "";
    objsales.dispatchTrough = formdata.dispatchTrough || "";
    objsales.additionalAmt = Number(formdata.addition) || 0.0;
    objsales.discAmt = Number(formdata.subtraction) || 0;
    objsales.roundOff = Number(formdata.round) || 0;
    objsales.grossTotal = totalGross || 0.0;
    objsales.discountTotal = totalDiscount || 0.0;
    objsales.taxTotal = totalTax || 0.0;
    objsales.netTotal = totalNet || 0.0;
    objsales.terms = formdata.terms || "";

    if (formdata.paymentType === 0) {
      objsales.cash = totalNet || 0;
    } else if (formdata.paymentType === 1) {
      objsales.bank = totalNet || 0;
    } else if (formdata.paymentType === 2) {
      objsales.upi = totalNet || 0;
    } else if (formdata.paymentType === 3) {
      objsales.card = totalNet || 0;
    }
    const objfinance = new FinancialYear();
    objfinance.id = branchsettings?.defaultFinancialYearID;
    objsales.financialYear = objfinance;
    objsales.Company = companyInfolist[0];

    const detailObj = formdata?.items?.map((e) => {
      console.log("Processing item:", e);

      let product;
      const productValue = e.product || e.product.value;
      console.log("productValue", productValue);
      product = productList?.find((item) => item.guid == productValue);
      const unit = unitList?.find((item) => item.guid == e.unit);
      const taxPercentage=taxvalue?.find((item)=>item.guid==e.taxPercentage)?.value
      const detailObj = {
        product,
        unit,

        quantity: e.quantity,
        price: e.price,
        mrp: e.mrp || 0.0,

        taxamnt: e.taxAmount,
        grossAmount: e.gross,
        netAmt: e.netTotal,
        expiryDate: dayjs(),

        taxPercentage
      };

      console.log("Detail object constructed:", detailObj);

      return detailObj;
    });
    objsales.invSalesDetails = detailObj;
    try {
      const response = await addEditSales(objsales);
      console.log("response", response);

      if (response) {
        toast.success("Success");
        handleRefresh();
        handleClose();
                    if (printAfterSubmit) {
           printA4Function();      // 👈 only called if user clicked "Save & Print"
           setPrintAfterSubmit(false); // reset flag
         }
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error(
        "Error handling :",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

    // const generateFatooraQR = (sellerName, vatNumber, invoiceDate, invoiceTotal, vatTotal) => {
    //   const encodeTLV = (tag, value) => {
    //     const encodedTag = Buffer.from([tag]).toString("hex");
    //     const encodedLength = Buffer.from([value.length]).toString("hex");
    //     const encodedValue = Buffer.from(value, "utf-8").toString("hex");
    //     return encodedTag + encodedLength + encodedValue;
    //   };
    
    //   const qrDataHex =
    //     encodeTLV(1, sellerName) +
    //     encodeTLV(2, vatNumber) +
    //     encodeTLV(3, invoiceDate) +
    //     encodeTLV(4, invoiceTotal) +
    //     encodeTLV(5, vatTotal);
    
    //   const qrDataBase64 = Buffer.from(qrDataHex, "hex").toString("base64");
    //   return qrDataBase64;
    // };
  

    const generateFatooraQR = (sellerName, invoiceDate, invoiceTotal, vatTotal) => {
      const encodeTLV = (tag, value) => {
        const safeValue = value ? String(value) : "";
        const tagBuffer = Buffer.from([tag]);
        const lengthBuffer = Buffer.from([safeValue.length]);
        const valueBuffer = Buffer.from(safeValue, "utf8");
    
        return Buffer.concat([tagBuffer, lengthBuffer, valueBuffer]);
      };
    
      const qrBuffer = Buffer.concat([
        encodeTLV(1, sellerName),
        encodeTLV(2, invoiceDate),
        encodeTLV(3, invoiceTotal),
        encodeTLV(4, vatTotal),
      ]);
    
      return qrBuffer.toString("base64");
    };

    const printA4Function = async() => {
      const form = document.getElementById("invoice-content");
    
      if (!form) {
        console.error("Element with ID 'invoice-content' not found.");
        return;
      }
  
      // const company = companyInfolist.length > 0 ? companyInfolist[0] : {}; // Assuming single company info
  
      // // Extract company details
      // const companyName = company.name || "Company Name";
      // const companyAddress1 = company.address1 || "";
      // const companyAddress2 = company.address2 || "";
      // const companyAddress3 = company.address3 || "";
      // const companyPhone = company.phone || "";
      // const companyVAT = company.tin || "";
      // Extract values from form inputs
      
      const company = printSettings?.[0] ?? {};


    // Extract company details
    const companyName = company.companyName || "Company Name";
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";
  
      
           const supplierGuid = watch("customer");
     const supplierObj = customerList.find(sup => sup.guid === supplierGuid) || {};
     const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
     const supplierAddress1 = supplierObj.address1 || "";
     const supplierMobile = supplierObj.mobile || "";
     const supplierVAT = supplierObj.gstNo || "";   
      
      const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";
  
  const date = new Date(watch("invdate")).toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
  const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString("en-GB");
  const invDateValue = watch("invdate") || new Date().toISOString();
    const invoiceDate = new Date(invDateValue).toISOString();
      const customerName = form.querySelector("input[name='customerName']")?.value || "";
      const contactNumber = form.querySelector("input[name='customerContactno']")?.value || "";
      const fields = watch("items") || [];
  // const discount = fields.reduce((sum, item) => sum + (parseFloat(item.discountAmount) || 0), 0);
  // const taxTotal = fields.reduce((sum, item) => sum + (parseFloat(item.taxAmount) || 0), 0);
  const  netTotal = fields.reduce((sum, item) => sum + (parseFloat(item.netTotal) || 0), 0);
  // const addition = parseFloat(watch("addition")) || 0;
  // const round = parseFloat(watch("round")) || 0;
  // Store the totals in React Hook Form
  // setValue("discount", discount.toFixed(2));
  // setValue("taxTotal", taxTotal.toFixed(2));
  // setValue("netTotal", netTotal.toFixed(2));
  
  const grossTotalPrint = Number(totalGross) || 0;
  const discountPrint = Number(totalDiscount) || 0;
  const taxTotalPrint = Number(totalTax) || 0;
  const netTotalPrint = Number(totalNet) || 0;
  
  const additionPrint = Number(watch("addition")) || 0;
  const roundPrint = Number(watch("round")) || 0;
  
  
  console.log({ totalDiscount, totalTax, totalNet });
  
    
      // Extract table data
    
  
    // const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map(row => {
    //   // Query the react-select component for the current row
    //   const selectContainer1 = row?.querySelector('.css-b62m3t-container');
    //   const selectContainer = selectContainer1?.querySelector('.react-select__control');
    //   const selectContainer3 = selectContainer?.querySelector('.react-select__value-container');
    //   const selectedValueDiv = selectContainer3?.querySelector('.react-select__single-value');
    
    //   // Extract the text or value of the selected option
    //   const selectedValue = selectedValueDiv?.textContent || "N/A";
    
    //   // Extract other values from the row (quantity, rate, total)
    //   return {
    //     description: selectedValue,
    //     qty: parseInt(row.querySelector("td:nth-child(6) input")?.value?.trim()) || 0,
    //     rate: parseFloat(row.querySelector("td:nth-child(7) input")?.value?.trim()) || 0.00,
    //     total: parseFloat(row.querySelector("td:nth-child(10) input")?.value?.trim()) || 0.00
    //   };
    // });
  const paymentTypeLabel =
    paymentType?.find(p => p.value === watch("paymentType"))?.label || "";
  
  
    //     const tableRows = Array.from(form.querySelectorAll("tbody tr")).map((row, index) => ({
    //   description: row.querySelector('td[data-label="Description"]')?.innerText || "",
    //   code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
    //   hsnCode: row.querySelector('td[data-label="HSN Code"] input')?.value || "",
    //   qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
    //   unit: row.querySelector('td[data-label="Unit"] input')?.value || "",
    //   rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
    //   discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
    //   tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
    //   total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
    //   netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
    // }));
    const tableRows = Array.from(form.querySelectorAll("tbody tr")).map((row) => {
    const unitText =
      row
        .querySelector('td[data-label="Unit"] .react-select__single-value')
        ?.textContent || "";
  
    return {
      description: row.querySelector('td[data-label="Description"]')?.innerText || "",
      code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
      qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
      unit: unitText,
      rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
      tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
        discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
      total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
      netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
    };
  });
  
    console.log(tableRows,"lkkk");
  
    // const qrData = `Company: ${companyName}\nDate: ${date}\nDelivery Date: ${deliveryDate}\nNet Total: ${netTotal.toFixed(2)}`;
      
    //   const qrCodeUrl = await QRCode.toDataURL(qrData);
  
    const fatooraQRData = generateFatooraQR(companyName, invoiceDate, netTotalPrint.toFixed(2), taxTotalPrint.toFixed(2));
    const qrCodeUrl = await QRCode.toDataURL(fatooraQRData);
    
      // Generate printable content
      // const printableContent = `
      //   <html>
      //     <head>
      //       <title>Invoice</title>
      //       <style>
      //         body { font-family: Arial, sans-serif; padding: 20px; }
      //         table { width: 100%; border-collapse: collapse; margin-top: 10px; }
      //         .header { text-align: center; margin-bottom: 20px; }
      //         .qr-code { text-align: center; margin-top: 20px;}
      //         th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
      //         .text-right { text-align: right; }
      //         .totals-table { width: 100%; margin-top: 20px; border-collapse: collapse; }
      //         .totals-table td { border: none; padding: 5px; font-weight: bold; }
      //         .totals-table .label { text-align: right; width: 80%; }
      //         .totals-table .value { text-align: right; width: 20%; }
      //         @media print {
      //           body { margin: 0; }
      //         }
      //       </style>
      //     </head>
      //     <body>
      //       <div class="qr-code">
      //         <img src="${qrCodeUrl}" alt="QR Code" />
      //       </div>
      //      <div class="header">
      //         <h2>${companyName}</h2>
      //         <p>${companyAddress1}, ${companyAddress2}, ${companyAddress3}</p>
      //         <p>Phone: ${companyPhone}</p>
      //       </div>
           
      //       <p><strong>Entry No:</strong> ${entryNumber}</p>
      //       <p><strong>Date:</strong> ${date}</p>
      //       <p><strong>Delivery Date:</strong> ${deliveryDate}</p>
      //       <p><strong>Customer Name:</strong> ${customerName}</p>
      //       <p><strong>Contact Number:</strong> ${contactNumber}</p>
    
      //       <table>
      //         <thead>
      //           <tr>
      //             <th>Description</th>
      //             <th>Rate</th>
      //             <th>Qty</th>
      //             <th>Total</th>
      //           </tr>
      //         </thead>
      //         <tbody>
      //           ${tableRows
      //             .map(
      //               (row) => `
      //             <tr>
      //               <td>${row.description}</td>
      //               <td class="text-right">${row.rate.toFixed(2)}</td>
      //               <td class="text-right">${row.qty}</td>
      //               <td class="text-right">${row.total.toFixed(2)}</td>
      //             </tr>
      //           `
      //             )
      //             .join("")}
      //         </tbody>
      //       </table>
    
      //       <table class="totals-table">
      //         <tr>
      //           <td class="label">Discount:</td>
      //           <td class="value">${discount}</td>
      //         </tr>
      //         <tr>
      //           <td class="label">Tax Total:</td>
      //           <td class="value">${taxTotal}</td>
      //         </tr>
      //         <tr>
      //           <td class="label">Net Total:</td>
      //           <td class="value">${netTotal}</td>
      //         </tr>
      //       </table>
      //     </body>
      //   </html>
      // `;
    
  
  const amountInWords = (num) => {
    if (!num || isNaN(num)) return "";
  
    const a = [
      "", "One", "Two", "Three", "Four", "Five",
      "Six", "Seven", "Eight", "Nine", "Ten",
      "Eleven", "Twelve", "Thirteen", "Fourteen",
      "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
  
    const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  
    const numberToWords = (n) => {
      if (n < 20) return a[n];
      if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
      if (n < 1000)
        return (
          a[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " " + numberToWords(n % 100) : "")
        );
      if (n < 1000000)
        return (
          numberToWords(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 ? " " + numberToWords(n % 1000) : "")
        );
      return "";
    };
  
    const integerPart = Math.floor(num);
    const decimalPart = Math.round((num - integerPart) * 100);
  
    const riyalPart = numberToWords(integerPart);
    const halalahPart = decimalPart ? numberToWords(decimalPart) : "";
  
    return `${riyalPart} Riyal${
      halalahPart ? " and " + halalahPart + " Halalah" : ""
    } Only`;
  };
  
  
  const printableContent = `
  <!DOCTYPE html>
  <html lang="ar">
  <head>
  <meta charset="UTF-8" />
  <title>Tax Invoice</title>
  
  <style>
  @page { size: A4; margin: 10mm; }
  
  body {
    font-family: Arial, sans-serif;
    font-size: 11px;
    color: #000;
  }
  
  .center { text-align: center; }
  .left { text-align: left; direction: ltr; }
  .right { text-align: right; direction: rtl; }
  .bold { font-weight: bold; }
  
.header h2 {
  margin: 2px 0;
}
.header p { margin: 2px 0; }
  
  .invoice-title {
    margin: 16px 16px;
    font-weight: bold;
    
  }
  
  /* DEFAULT TABLE */
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  /* HEADER & INFO TABLES */
  th {
    border: 1px solid #000;
    padding: 4px;
  }
  
  .header table td,
  table:not(.items) td {
    border: 1px solid #000;
    padding: 4px;
  }
  
  /* ITEMS TABLE OUTER BORDER */
  .items {
    border: 1px solid #000;
  }
  
  /* ITEM HEADER GRID */
  .items thead th {
    border: 1px solid #000;
  }
  
  /* ITEM BODY — NO VERTICAL LINES */
  /* ITEM BODY — ONLY VERTICAL LINES (REFERENCE STYLE) */
  .items tbody td {
    border-top: none;
    border-bottom: none;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    padding: 6px 4px;
    text-align: center;
    height: 26px;
  }
  
  
  
  
  /* BOTTOM BORDER OF ITEMS */
  .items tbody tr:last-child td {
    border-bottom: 1px solid #000;
  }
  
  
  .small { font-size: 10px; }
  
  .no-border tr td { border: none; }
  
  .items th { font-size: 10px; }
  .items td { font-size: 11px; text-align: center; }
  
  /* FORCE ITEM TABLE HEIGHT */
  .items tbody {
    height: 500px;
  }
  .totals{
  border: 1px solid #000;
  }
  .totals tr td {
     border-top: none;
    border-bottom: none;
    border-left: none;
    border-right: none;
    padding: 6px 4px;
  }
  .totals td:last-child {
    border-left: 1px solid #000;
  }
  
  .footer-fixed {
    margin-top: 18px;
    font-size: 10px;

  }
  
  .footer-fixed tr td {
    border: none;
  }
  </style>
  </head>
  
  <body>
  
  <!-- HEADER (UNCHANGED AS REQUESTED) -->
  <div class="header center">
         <h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>
  
 
  
    <div class="invoice-title">TAX INVOICE &nbsp;&nbsp; الفاتورة الضريبية</div>
  </div>
  
  <!-- INVOICE INFO -->
  <table>
  <tr>
    <td class="left small"><b>Quotation No :</b> ${entryNumber}</td>
    <td class="center small"><b>Date :</b> ${date}</td>
    <td class="right small"><b>Type :</b> ${paymentTypeLabel}</td>
  </tr>
  </table>
  
  <!-- CUSTOMER DETAILS -->
  <table style="margin-top:4px;">
  <tr>
    <th colspan="4" class="center small">CUSTOMER DETAILS &nbsp;&nbsp; تفاصيل العميل</th>
  </tr>
  <tr>
    <td class="left small"><b>NAME</b></td>
    <td class="left">${supplierName}</td>
    <td></td>
    <td class="right small"><b>اسم</b></td>
  
  </tr>
  <tr>
    <td class="left small"><b>CONTACT</b></td>
    <td class="left">${supplierMobile}</td>
    <td>${supplierMobile}</td>
    <td class="right small"><b>رقم الاتصال</b></td> 
  </tr>
  <tr>
    <td class="left small"><b>VAT NO</b></td>
    <td class="left">${supplierVAT}</td>
      <td>${supplierVAT}</td>
    <td class="right small"><b>الرقم الضريبي</b></td>
  
  </tr>
  <tr>
    <td class="left small"><b>CR NO</b></td>
    <td class="left"></td>
      <td></td>
    <td class="right small"><b>رقم السجل التجاري</b></td>
  
  </tr>
  <tr>
    <td class="left small"><b>ADDRESS</b></td>
    <td colspan="3">${supplierAddress1}</td>
  </tr>
  </table>
  
  <!-- ITEMS -->
  <table class="items" style="margin-top:4px;">
  <thead>
  <tr>
    <th>Sl.No<br/>رقم</th>
    <th>Barcode<br/>الباركود</th>
    <th>Description<br/>الوصف</th>
    <th>Qty<br/>كمية</th>
    <th>Unit<br/>وحدة</th>
    <th>Unit Price<br/>سعر الوحدة</th>
    <th>Taxable Amt<br/>المبلغ الخاضع</th>
    <th>Tax Amt<br/>مبلغ الضريبة</th>
    <th>Total<br/>المجموع</th>
  </tr>
  </thead>
  
  <tbody>
  ${
  (() => {
    const minRows = 9;
    const emptyRows = minRows - tableRows.length;
  
    return `
    ${tableRows.map((row, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${row.code}</td>
      <td class="left">${row.description}</td>
      <td>${row.qty}</td>
      <td>${row.unit}</td>
      <td>${row.rate.toFixed(2)}</td>
      <td>${row.total.toFixed(2)}</td>
      <td>${row.tax.toFixed(2)}</td>
      <td>${row.netTotal.toFixed(2)}</td>
    </tr>
    `).join("")}
  
    ${Array.from({ length: Math.max(0, emptyRows) }).map(() => `
    <tr>
      <td>&nbsp;</td><td></td><td></td><td></td>
      <td></td><td></td><td></td><td></td><td></td>
    </tr>
    `).join("")}
    `;
  })()
  }
  </tbody>
  </table>
  
  <!-- TOTALS -->
  <table class="totals" style="margin-top:6px;">
  <tr>
    <td class="left small">
  VAT (${((taxTotalPrint / (netTotalPrint - taxTotalPrint)) * 100).toFixed(2)}%)
    </td>
    <td></td>
    <td class="right bold" style="padding-right:16px;">Total</td><td>المجموع</td> 
    <td class="right">${(netTotalPrint - taxTotalPrint).toFixed(2)}</td>
  </tr>
  <tr>
    <td colspan="2"></td>
    <td class="right bold" style="padding-right:16px;">VAT</td><td>ضريبة القيمة المضافة</td> 
    <td class="right">${taxTotalPrint.toFixed(2)}</td>
  </tr>
  <tr>
    <td colspan="2"></td>
    <td class="right bold" style="padding-right:16px;">Discount </td><td> تخفيض</td> 
    <td class="right">${discountPrint.toFixed(2)}</td>
  </tr>
  <tr>
    <td colspan="2"></td>
    <td class="right bold" style="padding-right:16px;">Sub Total </td><td>المجموع الفرعي</td> 
    <td class="right">${netTotal.toFixed(2)}</td>
  </tr>
  
  <tr>
    <td colspan="2"></td>
    <td class="right bold" style="padding-right:16px;">Addition</td><td>إضافة</td> 
    <td class="right">${additionPrint.toFixed(2)}</td>
  </tr>
  <tr>
    <td colspan="2"></td>
    <td class="right bold" style="padding-right:16px;">Round off</td><td >تقريب</td> 
    <td class="right">${roundPrint.toFixed(2)}</td>
  </tr>
  <tr>
    <td class="left bold">
       ${amountInWords(netTotalPrint)}
    </td>
    <td></td>
    <td class="right bold" style="padding-right:16px;">Net Total</td><td class="bold">صافي المجموع</td> 
    <td class="right bold">${netTotalPrint.toFixed(2)}</td>
  </tr>
  </table>
  
  <!-- QR & FOOTER -->
  <table class="footer-fixed">
  <tr>
    <td class="right bold" style="font-size:12px; padding-right:20px;">
      For ${companyName}<br/>
    </td>
  </tr>
  </table> 
  
  </body>
  </html>
  `;
  
  
  
      // Create an iframe for better printing
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0px";
      iframe.style.height = "0px";
      iframe.style.border = "none";
      document.body.appendChild(iframe);
    
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(printableContent);
      doc.close();
    
      iframe.contentWindow.focus();
      setTimeout(() => {
        iframe.contentWindow.print();
        iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
      }, 500);
    };

  return (
    <div>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog add-centered">
          <div className="modal-content">
            <div className="page-wrapper p-0 m-0">
              <div className="content p-0">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>
                      {" "}
                      {mode === "edit"
                        ? "Edit sales Quotation"
                        : "Add sales Quotation"}
                    </h4>
                  </div>
                  <button type="button" className="close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="card">
                  <div className="card-body">
                    <form id="invoice-content" onSubmit={handleSubmit(handleFormSubmit)}>
                      <div className="row">
                        {/* row1 */}
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">Entry No.</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("entrynumber")}
                              required
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label>Date</label>
                            <div className="input-groupicon calender-input">
                              <Calendar className="info-img" />
                              <Controller
                                control={control}
                                name="invdate"
                                render={({ field: { onChange, value } }) => (
                                  <DatePicker
                                    className="datetimepicker"
                                    value={value ? dayjs(value) : dayjs()}
                                    format="DD-MM-YYYY"
                                    onChange={(date) =>
                                      onChange(
                                        date ? date.format("YYYY-MM-DD") : null
                                      )
                                    } // Update on change
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label>Invoice Date</label>
                            <div className="input-groupicon calender-input">
                              <Calendar className="info-img" />
                              <Controller
                                control={control}
                                name="deliveryDate"
                                render={({ field: { onChange, value } }) => (
                                  <DatePicker
                                    className="datetimepicker"
                                    value={value ? dayjs(value) : dayjs()}
                                    format="DD-MM-YYYY"
                                    onChange={(date) =>
                                      onChange(
                                        date ? date.format("YYYY-MM-DD") : null
                                      )
                                    } // Update on change
                                  />
                                )}
                              />
                              {errors.deliveryDate && (
                                <span className="text-danger small mt-1">
                                  {errors.deliveryDate.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">
                              Payment Type<span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <Controller
                                control={control}
                                name={`paymentType`}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    classNamePrefix="react-select"
                                    options={paymentType}
                                    value={paymentType?.find(
                                      (paymentType) =>
                                        paymentType?.value === value
                                    )}
                                    onChange={(selectedOption) =>
                                      onChange(selectedOption.value)
                                    }
                                    styles={{
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    required
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">Remarks</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("terms")}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks add-product">
                            <label>
                              Customer<span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <div className="col-lg-10 col-sm-10 col-10">
                                <Controller
                                  control={control}
                                  name={`customer`}
                                  render={({ field: { onChange, value } }) => (
                                    <Select
                                      classNamePrefix="react-select"
                                      options={customerData}
                                      value={customerData?.find(
                                        (customer) => customer?.value === value
                                      )}
                                      onChange={(selectedOption) =>
                                        onChange(selectedOption.value)
                                      }
                                      styles={{
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      required
                                    />
                                  )}
                                />
                              </div>
                              <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                <div className="add-icon tab">
                                  <Link
                                    to="#"
                                    onClick={() => {
                                      setModalOpen(true);
                                      //handleCustomerList();
                                    }}
                                  >
                                    <PlusCircle className="feather-plus-circles" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                           <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">
                              Ware House<span className="text-danger">*</span>
                            </label>
                            <div className="row">
 {/* <Controller
  name="location"
  control={control}
  render={({ field }) => (
    <Select
      classNamePrefix="react-select"
      {...field}
      options={formattedWarehouses}
      placeholder="Select Location"
      onChange={(selectedOption) => {
        field.onChange(selectedOption.value); // now value is the full warehouse object
      }}
      value={
        field.value
          ? { label: field.value.name, value: field.value }
          : null
      }
           styles={{
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                      }}
    />
  )}
/> */}
<Controller
  name="location"
  control={control}
  render={({ field }) => (
    <Select
      classNamePrefix="react-select"
      options={formattedWarehouses}
      required
      placeholder="Select Warehouse"
      value={getSelectedWarehouseOption(field.value)}
      onChange={(option) => field.onChange(option.value)}
      styles={{
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
      }}
    />
  )}
/>
                            </div>
                          </div>
                        </div>
                        {/* row 3 */}
                      </div>

                      <div className="table-responsive  no-pagination table-container">
                        <table className="table tablezind">
                          <thead>
                            <tr>
                              <th className="sticky-header">
                                Description
                                <span className="text-danger">*</span>
                              </th>
                              <th className="sticky-header">Item Code</th>
                              {/* <th className="sticky-header">HSN Code</th> */}
                              <th className="sticky-header">Unit</th>
                              <th className="sticky-header">
                                Quantity<span className="text-danger">*</span>
                              </th>
                              <th className="sticky-header">
                                Price <span className="text-danger">*</span>
                              </th>
                              <th className="sticky-header">MRP </th>
                              <th className="sticky-header">Gross</th>
                              {branchsettings.disableTaxInSale == false && (
                                <th className="sticky-header">Tax %</th>
                              )}
                              {branchsettings.disableTaxInSale == false && (
                                <th className="sticky-header">Tax Amount</th>
                              )}
                              <th className="sticky-header">Net Amount</th>
                              <th className="sticky-header">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fields?.map((field, index) => {
                              return (
                                <tr key={field.id}> 
                                  <td data-label="Description">
                                    <Controller
                                      control={control}
                                      name={`items[${index}].product`}
                                      rules={{
                                        required: "Product is required",
                                        validate: (value) => {
                                          const selectedProducts = watch(
                                            "items"
                                          )?.map((item) => item.product); // Get all selected products
                                          const isDuplicate =
                                            selectedProducts?.filter(
                                              (product) => product === value
                                            )?.length > 1;
                                          return (
                                            !isDuplicate ||
                                            "Duplicate product selected!"
                                          );
                                        },
                                      }}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          options={formatedproductList}
                                          value={formatedproductList?.find(
                                            (option) => option.value === value
                                          )}
                                          onChange={(selectedOption) => {
                                            onChange(selectedOption.value);
                                            handleEachProductfetch(
                                              selectedOption,
                                              index
                                            );
                                          }}
                                          styles={{
                                            menu: (provided) => ({
                                              ...provided,
                                              zIndex: 9999,
                                              position: "relative",
                                            }),
                                          }}
                                        />
                                      )}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.product && (
                                        <span className="text-danger small">
                                          {errors.items[index].product.message}
                                        </span>
                                      )}
                                  </td>
                                  <td data-label="Item Code">
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].code`)}
                                      disabled
                                    />
                                  </td>
                                  {/* <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].hsnCode`)}
                                      disabled
                                    />
                                  </td> */}
                                  <td data-label="Unit">
                                    <Controller
                                      control={control}
                                      name={`items[${index}].unit`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          options={unitData}
                                          value={unitData?.find(
                                            (option) => option.value === value
                                          )}
                                          onChange={(selectedOption) => {
                                            onChange(selectedOption.value);
                                          }}
                                          isDisabled={true}
                                        />
                                      )}
                                    />
                                  </td>

                                  <td data-label="Quantity">
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].quantity`, {
                                        required: "Quantity is required",
                                        validate: (value) =>
                                          (!isNaN(value) && value > 0) ||
                                          "Quantity must be a positive number",
                                      })}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.quantity && (
                                        <span className="text-danger small">
                                          {errors.items[index].quantity.message}
                                        </span>
                                      )}
                                  </td>
                                  <td data-label="Price">
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].price`, {
                                        required: "Price is required",
                                        validate: (value) =>
                                          (!isNaN(value) && value > 0) ||
                                          "Price must be a positive number",
                                      })}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.price && (
                                        <span className="text-danger small">
                                          {errors.items[index].price.message}
                                        </span>
                                      )}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].mrp`, {
                                        validate: (value) =>
                                          (!isNaN(value) && value >= 0) ||
                                          "MRP must be zero or more",
                                      })}
                                         // defaultValue={0} 
                                          
                                    />
                                    {errors.items &&
                                      errors.items[index]?.mrp && (
                                        <span className="text-danger small">
                                          {errors.items[index].mrp.message}
                                        </span>
                                      )}
                                  </td>

                                  <td data-label="Gross">
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].gross`)}
                                      disabled
                                    />
                                  </td>
                                  {branchsettings.disableTaxInSale == false && (
                                    // <td>
                                    //   <Controller
                                    //     control={control}
                                    //     name={`items[${index}].taxPercentage`}
                                    //     render={({
                                    //       field: { onChange, value },
                                    //     }) => (
                                    //       <Select
                                    //         classNamePrefix="react-select"
                                    //         options={taxData}
                                    //         placeholder="select"
                                    //         isClearable
                                    //         value={taxData?.find(
                                    //           (option) => option.value === value
                                    //         )}
                                    //         onChange={(selectedOption) => {
                                    //           onChange(
                                    //             selectedOption
                                    //               ? selectedOption.value
                                    //               : null
                                    //           );
                                    //         }}
                                    //         styles={{
                                    //           menu: (provided) => ({
                                    //             ...provided,
                                    //             zIndex: 9999,
                                    //             position: "relative",
                                    //           }),
                                    //         }}
                                    //       />
                                    //     )}
                                    //   />
                                    // </td>

                                  //   <td>
                                  //   <Controller
                                  //     control={control}
                                  //     name={`items[${index}].taxPercentage`}
                                  //     render={({
                                  //       field: { onChange, value },
                                  //     }) => (
                                  //       <>
                                  //       {/* {JSON.stringify(value)}
                                  //       {JSON.stringify(taxvalue.find((o)=>o.guid==value)?.value)} */}
                                  //       <Select
                                  //         classNamePrefix="react-select"
                                  //         options={taxvalue}
                                  //         value={taxvalue?.find(
                                  //           (option) => option.guid===value
                                  //         )}
                                          
                                  //         onChange={(selectedOption) => {
                                  //           onChange(selectedOption.value);
                                  //         }}
                                  //         isDisabled={true}
                                  //       />
                                  //       </>

                                  //     )}
                                  //   />
                                  // </td>
<td>
  <Controller
    control={control}
    name={`items[${index}].taxPercentage`}
    render={({ field: { onChange, value } }) => (
      <Select
        classNamePrefix="react-select"
        options={taxvalue}
        value={getSelectedTaxOption(value)} // cleaner & correct
        onChange={(selectedOption) => {
          onChange(selectedOption.guid); // store GUID
        }}
        isDisabled={true}
      />
    )}
  />
</td>

                                  )}
                                  {branchsettings.disableTaxInSale == false && (
                                    <td data-label="Tax Amount">
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(
                                          `items[${index}].taxAmount`
                                        )}
                                        disabled
                                      />
                                    </td>
                                  )}
                                  <td data-label="Net Amount">
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].netTotal`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <Link
                                      className="confirm-text p-2"
                                       onClick={() => handleRemove(index)}
                                    >
                                      <i
                                        data-feather="trash-2"
                                        className="feather-trash-2"
                                      ></i>
                                    </Link>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="col-lg-2 col-sm-2 col-2 ps-0 ">
                        <button
                          className=" btn btn-dark add-icon tab  mt-3 "
                          type="button"
                          onClick={handleAddRow}
                        >
                          <PlusCircle className="feather-plus-circles" />
                        </button>
                      </div>
                      <div className="row mt-3">
                        <div className=" col-4 ">
                          <div className="input-blocks">
                            <label>Addition</label>
                            <div className="input-groupicon select-code">
                              <input
                                type="number"
                                step="any"
                                min={0}
                                className="form-control p-2"
                                defaultValue={0}
                                {...register(`addition`)}
                              />
                              {errors.addition && (
                                <span className="text-danger small mt-1">
                                  {errors.addition.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className=" col-4 ">
                          <div className="input-blocks">
                            <label>Discount</label>
                            <div className="input-groupicon select-code">
                              <input
                                type="number"
                                step="any"
                                min={0}
                                className="form-control p-2"
                                defaultValue={0}
                                {...register(`subtraction`, {
                                  validate: (value) => {
                                    const discount = safeNumber(value);
                                    const totalNetAfterDiscount =
                                      totalNet - discount;
                                    if (discount < 0) {
                                      return "Discount value should not be negative.";
                                    } else if (totalNetAfterDiscount < 0) {
                                      return "Please enter a discount value that does not exceed the Net Total.";
                                    }
                                    return true;
                                  },
                                })}
                              />
                              {errors.subtraction && (
                                <span className="text-danger small mt-1">
                                  {errors.subtraction.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className=" col-4 ">
                          <div className="input-blocks">
                            <label>Round Off</label>
                            <div className="input-groupicon select-code">
                              <input
                                type="number"
                                step="any"
                                min={0}
                                className="form-control p-2"
                                defaultValue={0}
                                {...register(`round`, {
                                  validate: (value) => {
                                    console.log("Round value entered:", value);
                                    const round = safeNumber(value);
                                    const totalNetAfterRound = totalNet - round;
                                    return (
                                      totalNetAfterRound >= 0 ||
                                      "Please enter a round-off value that does not exceed Net Total."
                                    );
                                  },
                                })}
                              />
                              {errors.round && (
                                <span className="text-danger small mt-1">
                                  {errors.round.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 ms-auto">
                          <div className="total-order w-100 max-widthauto m-auto mb-4">
                            <ul>
                              <li>
                                <h4>Gross</h4>
                                <h5> {totalGross?.toFixed(decimalpoints)}</h5>
                              </li>
                              <li>
                                <h4>Discount</h4>
                                <h5>{totalDiscount?.toFixed(decimalpoints)}</h5>
                              </li>
                              <li>
                                <h4>Tax Total</h4>
                                <h5> {totalTax?.toFixed(decimalpoints)}</h5>
                              </li>
                              <li>
                                <h4>Net Total</h4>
                                <h5> {totalNet?.toFixed(decimalpoints)}</h5>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-12 text-end">
         <button
  type="submit"
  className="btn btn-cancel add-cancel me-3"
  onClick={() => setPrintAfterSubmit(true)} // 👈 set flag before submit
>
  Save & Print
</button>
                          <button
                            type="button"
                            className="btn btn-cancel add-cancel me-3"
                            onClick={resetmodal}
                          >
                            Reset
                          </button>
                          <button
                            className="btn btn-submit add-sale"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOpen && (
        <CustomerModal
          mode="add"
          data={{}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {}}
        />
      )}
    </div>
  );
};
export default SalesQuotationModal;
